import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32dd5d47"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("状态")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("不通过")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("不显示")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("显示")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("登陆才展示")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("不登录也展示")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "求购列表" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          name: "basic",
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.searches.search,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.search) = $event)),
                  placeholder: "标题",
                  style: {"width":"200px"}
                }, null, 8, ["value"]),
                _createVNode(_component_a_input, {
                  value: _ctx.searches.mobile,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.mobile) = $event)),
                  placeholder: "电话",
                  style: {"width":"200px","margin-left":"10px"}
                }, null, 8, ["value"]),
                _createVNode(_component_a_button, {
                  style: {"margin-left":"10px"},
                  type: "primary",
                  onClick: $setup.onSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  style: {"margin-left":"10px"},
                  onClick: $setup.onReset
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'image')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_a_image, {
                    src:  record.image.split(',')[0],
                    style: {"width":"50px"}
                  }, null, 8, ["src"])
                ]))
              : _createCommentVNode("", true),
            (column.key == 'oldnew')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(record.oldnew == 0 ? '不限' : record.oldnew==1 ? "全新" : "二手"), 1))
              : _createCommentVNode("", true),
            (column.key == 'category')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(record.category.name), 1))
              : _createCommentVNode("", true),
            (column.key == 'is_shop_show')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(record.is_shop_show == 0 ? '不显示' :  "显示"), 1))
              : _createCommentVNode("", true),
            (column.key == 'status')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(record.status == 1 ? '通过' : "不通过"), 1))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin":"5px"},
                    onClick: ($event: any) => ($setup.onStatus(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin":"5px"},
                    onClick: ($event: any) => ($setup.getdetail(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.viseable,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.viseable) = $event)),
      title: "控制状态",
      onOk: $setup.handleOk
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { model: _ctx.formState }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.wantData.status,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.wantData.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "是否显示" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.wantData.is_shop_show,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.wantData.is_shop_show) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "登录显示" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.wantData.plat_show,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.wantData.plat_show) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visableDetail,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visableDetail) = $event)),
      title: "求购详情",
      width: "1400px",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, { bordered: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "用户名" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.userdata.nickname), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "电话" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.phone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "求购标题" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.title), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "商品图片" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.image.split(','), (item, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, [
                    _createVNode(_component_a_image, {
                      src: item,
                      style: {"width":"50px","margin-left":"10px"}
                    }, null, 8, ["src"])
                  ]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "数量" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.num), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "单位" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.unit), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "分类" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.category.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "描述" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.describe), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "联系人" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.linkman), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "新旧" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.oldnew == 0 ? '不限' : _ctx.detailData.oldnew==1 ? "全新" : "二手"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "型号" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.version), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "最低价" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.min_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "最高价" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.max_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "是否显示" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.is_shop_show == 0 ? '不显示' :  "显示"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.status == 0 ? '通过' :  "不通过"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "登录显示" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.plat_show == 0 ? '登陆才展示' :  "不登录也展示"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "地址" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.address), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}